/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".save[_ngcontent-%COMP%]{min-width:380px}.save__message[_ngcontent-%COMP%]{color:#6a82a4;margin:12px auto;font-size:12px}.save__radio-group[_ngcontent-%COMP%]{display:flex;flex-direction:column}.save__permission[_ngcontent-%COMP%]{display:block;margin:4px auto}"];
export { styles as styles };
